import { Client } from "@/Common/Api/Client";
import { ClientResponse } from "@/Common/Api/ClientResponse";
import { Guid } from "@/Common/Models/Guid";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { FlowsheetFilterSettings } from "../Models/FlowsheetFilterSettings";
import { CreateFlowsheetRequest, CreateFlowsheetResponse } from "./Contracts/CreateFlowsheet";
import { FindFlowsheetSummariesResponse } from "./Contracts/FindFlowsheetSummaries";
import { GetFlowsheetResponse } from "./Contracts/GetFlowsheet";
import { GetFlowsheetsCountResponse } from "./Contracts/GetFlowsheetsCount";
import { SaveFlowsheetRequest } from "./Contracts/SaveFlowsheet";

class FlowsheetClient {
    /**
    * Creates a flowsheet
    */
    public static async createFlowsheet(createFlowsheetRequest: CreateFlowsheetRequest): Promise<ClientResponse<CreateFlowsheetResponse>> {
        return await Client.postAsync<CreateFlowsheetResponse>(ServerOperations.Server.Myle_FlowsheetModule_CreateFlowsheet, createFlowsheetRequest);
    }

    /**
    * Get the list of flowsheets for a specific encounter or for a sepecfic patient
    */
    public static async findFlowsheetSummaries(params: { encounterId?: Guid, patientId?: Guid }): Promise<FindFlowsheetSummariesResponse> {
        const { data } = await Client.postAsync<FindFlowsheetSummariesResponse>(
            ServerOperations.Server.Myle_FlowsheetModule_FindFlowsheetSummaries,
            {
                EncounterId: params.encounterId,
                PatientId: params.patientId
            }
        );

        return data;
    }

    /**
    * Get the count of flowsheets for a specific encounter
    */
    public static async getFlowsheetsCount(encounterId: Guid): Promise<GetFlowsheetsCountResponse> {
        const { data } = await Client.postAsync<GetFlowsheetsCountResponse>(ServerOperations.Server.Myle_FlowsheetModule_GetFlowsheetsCount, { EncounterId: encounterId });

        return data;
    }

    /**
    * Saves the flowsheet
    */
    public static async saveFlowsheet(flowsheet: SaveFlowsheetRequest): Promise<ClientResponse> {
        return await Client.postAsync(ServerOperations.Server.Myle_FlowsheetModule_SaveFlowsheet, flowsheet);
    }

    /**
    * Deletes the flowsheet
    */
    public static async deleteFlowsheet(flowsheetId: Guid): Promise<ClientResponse> {
        return await Client.postAsync(ServerOperations.Server.Myle_FlowsheetModule_DeleteFlowsheet, { FlowsheetId: flowsheetId });
    }

    /**
    * Get a flowsheet by Id
    */
    public static async getFlowsheet(flowsheetId: Guid): Promise<ClientResponse<GetFlowsheetResponse>> {
        return await Client.postAsync<GetFlowsheetResponse>(ServerOperations.Server.Myle_FlowsheetModule_GetFlowsheet, { Id: flowsheetId });
    }

    /**
    * Print the flowsheet
    */
    public static async printFlowsheet(flowsheetId: Guid, filterSettings?: FlowsheetFilterSettings): Promise<ClientResponse<{ FileName: string }>> {
        return await Client.postAsync<{ FileName: string }>(ServerOperations.Server.Myle_FlowsheetModule_PrintFlowsheet, { Id: flowsheetId, FilterSettings: filterSettings });
    }
}

export { FlowsheetClient };
